import { createApiRef } from '@backstage/core-plugin-api';

export type UpdateSecretsBody = {
  env: string;
  data: Record<string, string>;
};

export type UpdateSecretsResponse = {
  request_id: string;
  arn: string | null;
  tags: Record<string, string> | null;
};

export type SecretsBodyResponse = {
  arn: string | null;
  request_id: string;
  status: string;
  message: string;
  env: string;
  previous_version: string;
  data: {
    access_type: 'read' | 'write' | null;
    secrets: Record<string, string> | null;
    tags: Record<string, string> | null;
  };
};

export type RevertSecretVersionBody = {
  env: string;
  version_id: string;
};

export type PreviousSecretResponse = {
  previous_version: string | null;
};

export interface SecretsManagerClientApi {
  getSecrets(projectSlug: string, env: string): Promise<SecretsBodyResponse | undefined>;
  updateSecrets(projectSlug: string, body: UpdateSecretsBody): Promise<UpdateSecretsResponse>;
  revertSecret(projectSlug: string, body: RevertSecretVersionBody): Promise<UpdateSecretsResponse>;
}

export const sentinelSecretsManagerApiRef = createApiRef<SecretsManagerClientApi>({
  id: 'plugin.sentinel-secrets-manager.api',
});
